<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Profil bearbeiten"
    iconPath="assets/icons/identification-card.svg"
  />

  <div class="p-6">
    <form class="mb-10 text-gray-600">
      <p class="pb-2">
        Durch das Löschen deines Kontos werden alle personenbezogenen Daten anonymisiert, und dein
        Nutzerprofil wird unwiderruflich entfernt.
      </p>
      <p class="pb-2">Diese Aktion kann nicht rückgängig gemacht werden.</p>
      <p class="pb-8">
        Gib zur Bestätigung das Wort <strong>löschen</strong> ein und klicke anschließend auf
        <strong>Profil löschen</strong>.
      </p>

      <app-input
        type="text"
        label='Bitte "löschen" eingeben!'
        [control]="control"
      />
    </form>

    <app-button
      text="Profil löschen"
      variant="alert"
      [isLoading]="isLoading()"
      [disabled]="control.invalid"
      [fullWidth]="true"
      (clicked)="deleteUser()"
    />
  </div>
</div>
